import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { BranchService } from '@core/services/branch.service';
import { RoleType, setRoleType } from './organisation.model';

export interface OrganisationListItem {
  id: string;
  name: string;
  vatNumber: string;
  image: string;
  verified: boolean;
  member: boolean;
  admin: boolean;
  manager:boolean;
  isPremium:boolean;
  role:RoleType;
  allowsCourseRequest?:boolean;
  allowsCustomCourseRequest?:boolean;
}

@Injectable({
  providedIn: 'root'
})

export class OrganisationListItemAdapter implements Adapter<OrganisationListItem> {
  constructor(private branchService:BranchService){}

  adapt(item: any): OrganisationListItem {

    return {
      id: item.id??'',
      name: item.name??'',
      vatNumber:item.vatNumber??'',
      verified:item.isVerifiedMember??false,
      member:item.member??false,
      admin: item.isAdmin??false,
      manager:item.isManager??false,
      image: item.logo? (item.logo.fileUrl?(item.logo.fileUrl +'?filter=thumb&width=64&height=64&mode=outbound'):'' ) :'',
      // No premium features are allowed on vanity (branded partner) URLs, so treat the org as non-premium there.
      isPremium: (item.activeSubscription ?? false) && !this.branchService.vanityMode,
      role: setRoleType(item),
      allowsCourseRequest: (item.courseEnrolmentModuleEnabled??false),
      allowsCustomCourseRequest: (item.requestCustomCourseModuleEnabled??false),
    } as OrganisationListItem
  }
}
